import React from 'react';
import { IoCloseOutline } from 'react-icons/io5';

import InaviLogo from 'assets/images/logo/inavi_footer.png';
import BlackTextLogo from 'assets/images/logo/text_black.png';
import styled from 'styled-components';

const FooterLogo = () => {
  return (
    <FooterLogoWrapper className="footer_logo_box">
      <img src={InaviLogo} alt="inavi logo" className="inavi_footer" />
      <IoCloseOutline className="close_icon" />
      <img
        src={BlackTextLogo}
        alt="INAVI Maps logo"
        className="inavi_maps_footer"
      />
    </FooterLogoWrapper>
  );
};

export default FooterLogo;

const FooterLogoWrapper = styled.div`
  display: flex;
  align-items: center;

  img {
    object-fit: contain;
  }
  .inavi_footer {
    height: 38px;
  }
  .close_icon {
    margin-left: 2px;
    margin-right: 2px;
    color: ${({ theme }) => theme.color.gray600};
  }
  .inavi_maps_footer {
    height: 22px;
    margin-top: 1px;
  }

  @media screen and (max-width: 1025px) {
    .inavi_footer {
      height: 30px;
    }
    .inavi_maps_footer {
      height: 18px;
    }
  }
`;
